import React from 'react';
import { Outlet } from 'react-router-dom';
import { useProjectRouteGuard } from '../../hooks/useProjectRouteGuard';
import { AppLayout } from './AppLayout';

/**
 * Layout component for project routes (/projects/:projectId/*)
 * Handles project validation and route guarding
 */
export const ProjectRouteLayout: React.FC = () => {
  // The route guard handles all the project validation and URL syncing
  useProjectRouteGuard();

  return (
    <AppLayout>
      <Outlet />
    </AppLayout>
  );
};
